import { NumberField } from '@heroui/react';

// 贴 TDesign InputNumber 心智的数字输入封装,收敛 NumberField 多层结构
export function SimpleNumberInput({
  value,
  onChange,
  minValue,
  maxValue,
  className,
  isDisabled,
  'aria-label': ariaLabel,
}: {
  value: number;
  onChange: (value: number) => void;
  minValue?: number;
  maxValue?: number;
  className?: string;
  isDisabled?: boolean;
  'aria-label'?: string;
}) {
  return (
    <NumberField
      aria-label={ariaLabel ?? '数值'}
      className={className}
      value={value}
      minValue={minValue}
      maxValue={maxValue}
      isDisabled={isDisabled}
      // NumberField 空值回调给 NaN,归一到 minValue 或 0
      onChange={(v) => onChange(Number.isNaN(v) ? (minValue ?? 0) : v)}
    >
      <NumberField.Group>
        <NumberField.DecrementButton />
        <NumberField.Input />
        <NumberField.IncrementButton />
      </NumberField.Group>
    </NumberField>
  );
}
